import { useDealer } from "./useDealer";
import { useApiCall } from "@porchpass/ui";
import { getDealerPortalV1DealerIdApplicationDocumentsAppIdFull } from "@porchpass/api-client";
import {
  downloadBlobFile,
  extractFilenameFromContentDisposition,
} from "src/utils";

export const useFullApplicationDocument = (applicationId: string) => {
  const { dealer_id } = useDealer();

  const downloadApi = useApiCall(
    async () => {
      if (!dealer_id || !applicationId) {
        throw new Error("Application not found");
      }

      const response =
        await getDealerPortalV1DealerIdApplicationDocumentsAppIdFull(
          dealer_id,
          applicationId,
        );

      if (response.status !== 200) {
        throw new Error("Full application document not available");
      }

      const filename =
        extractFilenameFromContentDisposition(response.headers) ??
        `full-application-${applicationId}.pdf`;

      downloadBlobFile(response.data, filename);
    },
    {
      toast: {
        success: false,
        error: "The document is still being prepared. Please try again later.",
        useServerErrorMessage: true,
      },
    },
  );

  const downloadFullApplicationDocument = () => {
    void downloadApi.execute();
  };

  return {
    downloadFullApplicationDocument,
    isDownloading: downloadApi.isLoading,
  };
};
